// apiHeaders.js
function ApiHeaders() {
    const token = localStorage.getItem("accessToken");
    if (token) {
        return {
            authorization: `Bearer ${token}`,
        };
    }
    return {}; // Return an empty object if there's no token
}

export default ApiHeaders;
